import React, { useCallback } from "react";

import { Box, Typography } from "@mui/material";
import { SelectDateRange } from "components/forms/Select-date-range/SelectDateRange";
import { DateRangeValue } from "store/types";

interface Props {
  label: string;
  value: DateRangeValue | null;
  onChange: (value: DateRangeValue) => void;
}

export const SelectDateRangeField: React.FC<Props> = ({ label, value, onChange }) => {
  const handleChange = useCallback(
    (dateValue: DateRangeValue) => {
      onChange(dateValue);
    },
    [onChange]
  );

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        p: "2px 10px",
        height: "32px",
        borderRadius: "999px",
        border: "1px solid #dbe8f5",
        bgcolor: "#FFFFFF",
        position: "relative"
      }}
    >
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          color: "#92a7bc",
          textTransform: "uppercase",
          flexShrink: 0
        }}
      >
        {label}
      </Typography>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <SelectDateRange
          value={value}
          onChange={handleChange}
          dateRangeDialog={true}
          quarterRangeDialog={true}
          enableInceptionToLastNAV={false}
          hideOutline={true}
          selectProps={{
            sx: {
              "& .MuiSelect-select": {
                padding: "2px 20px 2px 0 !important",
                fontSize: 12,
                fontWeight: 700,
                color: "#071f35"
              },
              "&.MuiInputBase-root": {
                height: "auto",
                minHeight: "auto"
              }
            }
          }}
          formControlProps={{
            sx: {
              minWidth: "155px",
              "& .MuiInputLabel-root": {
                display: "none"
              },
              "& .MuiFormControl-root": {
                margin: 0
              }
            }
          }}
        />
      </Box>
    </Box>
  );
};
